import { render } from "./detail.vue?vue&type=template&id=2016b04a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=2016b04a&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2016b04a"]])

export default __exports__